<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('Pending')" class="mt-2">
            <pending></pending>
          </vs-tab>
          <vs-tab :label="$t('Confirmed')" class="mt-2">
            <confirmed></confirmed>
          </vs-tab>
          <vs-tab :label="$t('Rejected')" class="mt-2">
            <rejected></rejected>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Pending from "./Pending/Index.vue";
import Confirmed from "./Confirmed/Index.vue";
import Rejected from "./Rejected/Index.vue";

import "../../../assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "Content_management_Rejected_Index",
  components: {
    Pending,
    Confirmed,
    Rejected
  }
};
</script>
